var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Eventful from '../utils/Eventful';
import * as lodash from '../utils/lodash';
import easingFunctions from '../animate/ease';
import { interpolate } from '../interpolate';
import interpolatePath from '../interpolate/interpolatePath';
import interpolateColor from '../interpolate/interpolateColor';
import * as mat3 from '../../js/mat3';
import { transformMat3, vec2BBox, createVec2 } from '../utils/vec2';
import * as transformUtils from '../utils/transform';
import { RGBA_TRANSPARENT, IDENTRY_MATRIX } from '../constant';
import { unionBBox, ceilBBox, createZeroBBox, inBBox } from '../utils/bbox';
import { getSVGStyleAttributes } from '../svg/style';
import Shadow from '../svg/Shadow';
export var defaultSetting = {
    during: 300,
    ease: 'CubicOut',
};
var reuseBBoxVectors = [createVec2(), createVec2(), createVec2(), createVec2()];
export var defaultCanvasContext = {
    fill: 'none',
    stroke: 'none',
    lineWidth: 1,
    lineDash: null,
    lineDashOffset: 0,
    lineJoin: 'bevel',
    lineCap: 'butt',
    miterLimit: 10,
    fillOpacity: 1,
    strokeOpacity: 1,
    blendMode: 'source-over',
    fontSize: 12,
    fontFamily: 'sans-serif',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontVariant: 'normal',
    textAlign: 'start',
    textBaseline: 'bottom',
    shadowColor: RGBA_TRANSPARENT,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    cursor: 'auto',
    pointerEvents: 'auto',
};
var extendAbleKeys = Object.keys(defaultCanvasContext);
export var transformKeys = [
    'rotation',
    'scaleX',
    'scaleY',
    'translateX',
    'translateY',
    'originX',
    'originY',
    'matrix',
];
var animationKeysMap = {};
var defaultTRansformConf = {
    originX: 0,
    originY: 0,
    translateX: 0,
    translateY: 0,
    scaleX: 1,
    scaleY: 1,
    origin: [0, 0],
    position: [0, 0],
    scale: [0, 0],
};
var nodeId = 1;
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    function Element(attr) {
        var _this = _super.call(this) || this;
        _this.attr = {};
        _this.svgTagName = 'path';
        _this.parentNode = null;
        _this.firstChild = null;
        _this.lastChild = null;
        _this.prevSibling = null;
        _this.nextSibling = null;
        _this.ownerRender = null;
        _this.shapeKeys = [];
        _this.fillAble = true;
        _this.strokeAble = true;
        _this.needFill = false;
        _this.needStroke = false;
        _this._dirty = true;
        _this._animations = [];
        _this._bboxDirty = true;
        _this._transformDirty = false;
        _this._absTransformDirty = true;
        _this._clientBoundingRectDirty = true;
        _this._dragOffset = createVec2();
        _this._currentPaintAreaDirty = true;
        _this._inTransaction = false;
        _this._hasBeenPainted = false;
        _this.id = nodeId++;
        _this.attr = _this.getDefaultAttr();
        attr && _this.setAttr(attr);
        _this.created();
        return _this;
    }
    Object.defineProperty(Element.prototype, "dataset", {
        get: function () {
            return this.attr.data;
        },
        enumerable: true,
        configurable: true
    });
    Element.prototype.getAnimationKeys = function () {
        return [
            'fill',
            'stroke',
            'color',
            'lineWidth',
            'lineDash',
            'lineDashOffset',
            'opacity',
            'fillOpacity',
            'strokeOpacity',
            'rotation',
            'translateX',
            'translateY',
            'scaleX',
            'scaleY',
            'originX',
            'originY',
            'matrix',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY',
        ];
    };
    Element.prototype.getDefaultAttr = function () {
        return {
            display: true,
        };
    };
    Element.prototype.onEvent = function (type) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var _a;
        var eventKey = Object.keys(this.attr).filter(function (key) { return key.toLowerCase() === 'on' + type; })[0];
        if (eventKey) {
            this.attr[eventKey].apply(null, params);
        }
        (_a = this.attr.onEvent) === null || _a === void 0 ? void 0 : _a.apply(null, params);
    };
    Element.prototype.getComputedOpacity = function () {
        var _a;
        var node = this;
        var opacity = 1;
        while (node) {
            opacity *= (_a = node.attr.opacity) !== null && _a !== void 0 ? _a : 1;
            node = node.parentNode;
        }
        return opacity;
    };
    Element.prototype.getExtendAttr = function (key) {
        var value = defaultCanvasContext[key];
        var node = this;
        while (node) {
            if (typeof node.attr[key] !== 'undefined') {
                value = node.attr[key];
                break;
            }
            node = node.parentNode;
        }
        if ((key === 'fill' || key === 'stroke') && value === 'currentColor') {
            return this.getExtendAttr('color');
        }
        if (key !== 'lineWidth' || !this.attr.strokeNoScale) {
            return value;
        }
        var globalTransform = this.getGlobalTransform();
        var scale = globalTransform[0];
        return (value / scale);
    };
    Element.prototype.hasFill = function () {
        var fill = this.getExtendAttr('fill');
        return fill && fill !== 'none';
    };
    Element.prototype.hasStroke = function () {
        var stroke = this.getExtendAttr('stroke');
        return stroke && stroke !== 'none';
    };
    Element.prototype.contains = function (child) {
        var node = child;
        while (node) {
            if (node === this) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    };
    Element.prototype.getAncestorNodes = function (containSelf) {
        if (containSelf === void 0) { containSelf = true; }
        var node = containSelf ? this : this.parentNode;
        var out = [];
        while (node) {
            out.push(node);
            node = node.parentNode;
        }
        return out;
    };
    Element.prototype.getComputedAttr = function () {
        // todo
        return __assign(__assign(__assign({}, defaultCanvasContext), (this.parentNode ? lodash.pick(this.parentNode.attr, extendAbleKeys) : null)), this.attr);
    };
    Element.prototype.setAttr = function (attr, value) {
        if (!attr) {
            return this;
        }
        if (typeof attr === 'string') {
            if (this.attr[attr] === value) {
                return;
            }
            this.dirty();
            var oldValue = this.attr[attr];
            if (value !== undefined) {
                this.attr[attr] = value;
            }
            else {
                delete this.attr[attr];
                if (this.ownerRender && this.ownerRender.renderer === 'svg') {
                    this._removeSVGAttribute(attr);
                }
            }
            this.onAttrChange(attr, value, oldValue);
        }
        else if (typeof attr === 'object') {
            this.prevProcessAttr(attr);
            var dirty = false;
            for (var key in attr) {
                var prevValue = this.attr[key];
                var nextValue = attr[key];
                if (prevValue !== nextValue) {
                    if (!dirty) {
                        dirty = true;
                        this.dirty();
                    }
                    this.attr[key] = nextValue;
                    this.onAttrChange(key, nextValue, prevValue);
                }
            }
        }
        if (!this._inTransaction) {
            this.update();
        }
        return this;
    };
    Element.prototype.removeAttr = function (attribute) {
        this.setAttr(attribute, undefined);
    };
    Element.prototype.show = function () {
        this.setAttr('display', true);
    };
    Element.prototype.hide = function () {
        this.setAttr('display', false);
    };
    Element.prototype.startAttrTransaction = function () {
        this._inTransaction = true;
    };
    Element.prototype.endAttrTransaction = function () {
        this._inTransaction = false;
        this.update();
    };
    Object.defineProperty(Element.prototype, "isGroup", {
        get: function () {
            return this.type === 'group';
        },
        enumerable: true,
        configurable: true
    });
    Element.prototype.beforeDirty = function (leafNodeSize) {
        var maxDirtyLimit = this.ownerRender.maxDirtyRects;
        if (!this.ownerRender.enableDirtyRect ||
            this.ownerRender.getDirtyElements().size > maxDirtyLimit ||
            leafNodeSize > maxDirtyLimit) {
            this._dirtyRect = undefined;
            return;
        }
        if (!this._dirty && this._hasBeenPainted) {
            this._dirtyRect = this.getCurrentDirtyRect();
        }
    };
    Element.prototype.isDirty = function () {
        return this._dirty;
    };
    Element.prototype.onChildDirty = function () {
        // nothing;
    };
    Element.prototype.dirty = function (isRef) {
        if (isRef === void 0) { isRef = false; }
        var _a, _b;
        var leafNodeSize = 1;
        if (this.ownerRender &&
            this.ownerRender.renderer === 'canvas' &&
            this.ownerRender.enableDirtyRect) {
            (_a = this._refElements) === null || _a === void 0 ? void 0 : _a.forEach(function (item) { return item.dirty(true); });
            (_b = this.parentNode) === null || _b === void 0 ? void 0 : _b.onChildDirty();
            if (this.isGroup) {
                leafNodeSize = this.getLeafNodesSize(this.ownerRender.maxDirtyRects + 1);
                this.beforeDirty(leafNodeSize);
            }
            else {
                this.beforeDirty(leafNodeSize);
            }
        }
        this._dirty = true;
        if (this.ownerRender) {
            this.ownerRender.dirty(this);
            if (this.isGroup && this.ownerRender.renderer === 'canvas') {
                if (leafNodeSize > this.ownerRender.maxDirtyRects) {
                    this.ownerRender.getPainter().noDirtyRectNextFrame();
                }
            }
        }
        if (this.attr.clip && this.ownerRender) {
            this._mountClip();
        }
    };
    Element.prototype.clearDirty = function () {
        this._hasBeenPainted = true;
        this._dirty = false;
    };
    Object.defineProperty(Element.prototype, "childNodes", {
        get: function () {
            return this.children();
        },
        enumerable: true,
        configurable: true
    });
    Element.prototype.children = function () {
        var ret = [];
        var node = this.firstChild;
        while (node) {
            ret.push(node);
            node = node.nextSibling;
        }
        node = null;
        return ret;
    };
    Element.prototype.getShadowObj = function () {
        if (!this._shadow) {
            this._shadow = new Shadow();
        }
        this._shadow.setShadow(this.attr.shadowColor, this.attr.shadowBlur, this.attr.shadowOffsetX, this.attr.shadowOffsetY);
        return this._shadow;
    };
    Element.prototype.getBBox = function () {
        if (!this._bbox || this._bboxDirty) {
            this._bbox = this.computeBBox();
            this._bboxDirty = false;
        }
        return this._bbox;
    };
    Element.prototype.getBoundingClientRect = function () {
        if (this.attr.display === false) {
            return createZeroBBox();
        }
        if (!this._clientBoundingRect || this._clientBoundingRectDirty) {
            this._clientBoundingRect = this.computeBoundingClientRect(this._clientBoundingRect || createZeroBBox());
            this._clientBoundingRectDirty = false;
        }
        return this._clientBoundingRect;
    };
    Element.prototype.getDirtyRects = function () {
        var prevBBox = this._dirtyRect;
        var currentBBox = this.getCurrentDirtyRect();
        if (prevBBox) {
            return [prevBBox, currentBBox];
        }
        return [currentBBox];
    };
    Element.prototype.getCurrentDirtyRect = function () {
        if (!this._currentPaintArea || this._currentPaintAreaDirty) {
            this._currentPaintArea = this.computeCurrentDirtyRect();
            this._currentPaintAreaDirty = false;
        }
        return this._currentPaintArea;
    };
    Element.prototype.addRef = function (el) {
        if (!el) {
            return;
        }
        if (!this._refElements) {
            this._refElements = new Set();
        }
        this._refElements.add(el);
    };
    Element.prototype.removeRef = function (el) {
        var _a;
        (_a = this._refElements) === null || _a === void 0 ? void 0 : _a.delete(el);
    };
    Element.prototype.computeCurrentDirtyRect = function () {
        if (this.attr.display === false) {
            return createZeroBBox();
        }
        var _a = this.attr, markerStart = _a.markerStart, markerEnd = _a.markerEnd;
        var boundingRect = this.getBoundingClientRect();
        var x = boundingRect.x, y = boundingRect.y, width = boundingRect.width, height = boundingRect.height;
        var shadowBlur = this.getExtendAttr('shadowBlur');
        var hasSubBox = shadowBlur > 0 || markerStart || markerEnd;
        if (!hasSubBox) {
            return ceilBBox(boundingRect);
        }
        var boxList = [boundingRect];
        if (shadowBlur > 0) {
            var shadowOffsetX = this.getExtendAttr('shadowOffsetX');
            var shadowOffsetY = this.getExtendAttr('shadowOffsetY');
            boxList.push({
                x: x + shadowOffsetX - shadowBlur,
                y: y + shadowOffsetY - shadowBlur,
                width: width + shadowBlur * 2 + shadowOffsetX,
                height: height + shadowBlur * 2 + shadowOffsetY,
            });
        }
        if (markerStart || markerEnd) {
            if (markerStart) {
                boxList.push(markerStart.getMarkerDirtyRect(this, 'start'));
            }
            if (markerEnd) {
                boxList.push(markerEnd.getMarkerDirtyRect(this, 'end'));
            }
        }
        return ceilBBox(unionBBox(boxList));
    };
    Element.prototype.computeBBox = function () {
        return { x: 0, y: 0, width: 0, height: 0 };
    };
    Element.prototype.getSvgAttributes = function () {
        return getSVGStyleAttributes(this);
    };
    Element.prototype.computeBoundingClientRect = function (out) {
        // todo gc optimize
        var _a = this.getBBox(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var hasStroke = this.hasStroke();
        var lineWidth = hasStroke && !this.isGroup ? this.getExtendAttr('lineWidth') : 0;
        var offsetLineWidth = (Math.sqrt(2) / 2) * lineWidth;
        var matrix = this.getGlobalTransform(true);
        x -= offsetLineWidth;
        y -= offsetLineWidth;
        width += offsetLineWidth * 2;
        height += offsetLineWidth * 2;
        if (!matrix) {
            out.x = x;
            out.y = y;
            out.width = width;
            out.height = height;
            return out;
        }
        return this.computeBBoxWithTransform(out, x, y, width, height, matrix);
    };
    Element.prototype.computeBBoxWithTransform = function (out, x, y, width, height, matrix) {
        reuseBBoxVectors[0][0] = x;
        reuseBBoxVectors[0][1] = y;
        reuseBBoxVectors[1][0] = x + width;
        reuseBBoxVectors[1][1] = y;
        reuseBBoxVectors[2][0] = x + width;
        reuseBBoxVectors[2][1] = y + height;
        reuseBBoxVectors[3][0] = x;
        reuseBBoxVectors[3][1] = y + height;
        // const vectors: Vec2[] = [
        //   [x, y],
        //   [x + width, y],
        //   [x + width, y + height],
        //   [x, y + height],
        // ];
        reuseBBoxVectors.forEach(function (vec2) { return transformMat3(vec2, vec2, matrix); });
        return vec2BBox(reuseBBoxVectors, out);
    };
    Element.prototype.created = function () {
        // do nothing
    };
    Element.prototype.onAttrChange = function (key, newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        if (transformKeys.indexOf(key) !== -1) {
            this.dirtyTransform();
        }
        if (key === 'display') {
            this.dirtyBBox();
        }
        if (key === 'shadowBlur') {
            this._currentPaintAreaDirty = true;
        }
        if (this.shapeKeys.indexOf(key) !== -1) {
            this.dirtyBBox();
        }
        // if (key === 'clip' && this.attr.clip) {
        //   const clip = this.getClipElement();
        //   if (!clip.parentNode) {
        //     clip.destroy();
        //   }
        // }
        if (key === 'clip' && this.ownerRender) {
            this._mountClip();
        }
        if (key === 'ref' && newValue) {
            newValue.current = this;
        }
        if (key === 'lineWidth') {
            this.dirtyClientBoundingRect();
        }
    };
    Element.prototype.update = function () {
        // nothing
    };
    Element.prototype.mounted = function () {
        if (!(this.parentNode && this.parentNode.ownerRender)) {
            return;
        }
        if (this.parentNode) {
            this.ownerRender = this.parentNode.ownerRender;
            if (this.attr.onMounted || this._animations.length) {
                this._addToFrame();
            }
        }
        this._mountClip();
    };
    Element.prototype.resetPickRGB = function () {
        this.pickRGB = null;
    };
    Element.prototype.pickByGPU = function () {
        return false;
    };
    Element.prototype.isInShape = function (ox, oy) {
        var _a = this.getInvertedPoint(ox, oy), x = _a[0], y = _a[1];
        if (this.attr.pointerEvents === 'bounding-box') {
            return inBBox(this.getBBox(), x, y);
        }
        return this.isPointOnPath(x, y);
    };
    Element.prototype.isPointOnPath = function (x, y) {
        var hasFill = this.hasFill();
        var hasStroke = this.hasStroke();
        var lineWidth = this.getExtendAttr('lineWidth') + (this.attr.pickingBuffer || 0);
        return ((hasFill && this.isPointInFill(x, y)) || (hasStroke && this.isPointInStroke(x, y, lineWidth)));
    };
    /**
     *
     * @param x inverted x
     * @param y inverted y
     */
    Element.prototype.isInClip = function (x, y) {
        var _a;
        var inClip = true;
        var node = this;
        var invertedX;
        var invertedY;
        while (inClip && node) {
            if (node.attr.clip) {
                _a = node.getInvertedPoint(x, y), invertedX = _a[0], invertedY = _a[1];
                inClip = inClip && node.getClipElement().isPointInFill(invertedX, invertedY);
            }
            if (!inClip) {
                break;
            }
            node = node.parentNode;
        }
        return inClip;
    };
    Element.prototype.dirtyClipTarget = function (clip) {
        var myclip = this.getClipElement();
        if (myclip && myclip === clip) {
            this.dirty();
        }
    };
    Element.prototype.getInvertedPoint = function (x, y) {
        var globalTransform = this.getGlobalTransform(true);
        if (globalTransform) {
            var out = mat3.createVec3();
            var inverMatrix = mat3.invert(out, globalTransform);
            var vec2 = [0, 0];
            transformMat3(vec2, [x, y], inverMatrix);
            return vec2;
        }
        return [x, y];
    };
    Element.prototype.isPointInStroke = function (x, y, lineWidth) {
        x && y && lineWidth;
        return false;
    };
    Element.prototype.isPointInFill = function (x, y) {
        x && y;
        return false;
    };
    Element.prototype.destroy = function () {
        var _a;
        if (this._inFrameAble) {
            this._removeFromFrame();
        }
        this.parentNode = null;
        this.ownerRender = null;
        this.prevSibling = this.nextSibling = this.firstChild = this.lastChild = null;
        this._transformDirty = true;
        this._absTransformDirty = true;
        this._clientBoundingRectDirty = true;
        this._bboxDirty = true;
        (_a = this._refElements) === null || _a === void 0 ? void 0 : _a.clear();
        var clip = this.getClipElement();
        if (clip && !clip.parentNode) {
            clip.destroy();
        }
        this.stopAllAnimation();
        this.removeAllListeners();
    };
    Element.prototype.getDragOffset = function () {
        return this._dragOffset;
    };
    Element.prototype.setDragOffset = function (x, y) {
        if (this._dragOffset[0] === x && this._dragOffset[1] === y) {
            return;
        }
        this._dragOffset[0] = x;
        this._dragOffset[1] = y;
        this.dirty();
        this.dirtyGlobalTransform();
    };
    Element.prototype.dragMoveBy = function (dx, dy) {
        if (dx === 0 && dy === 0) {
            return;
        }
        this.dirty();
        this._dragOffset[0] += dx;
        this._dragOffset[1] += dy;
        this.dirtyGlobalTransform();
    };
    /* ************ AnimateAble Begin ******************* */
    Element.prototype.animateTo = function (toAttr, duringOrConf, ease, callback, delay) {
        var _this = this;
        if (duringOrConf === void 0) { duringOrConf = defaultSetting.during; }
        if (ease === void 0) { ease = defaultSetting.ease; }
        this.prevProcessAttr(toAttr);
        var fromAttr = this.attr;
        var animationKeys = animationKeysMap[this.type];
        if (!animationKeys) {
            animationKeys = this.getAnimationKeys();
            animationKeysMap[this.type] = animationKeys;
        }
        animationKeys = animationKeys.filter(function (key) {
            var toValue = toAttr[key];
            var fromValue = fromAttr[key];
            return !(lodash.isNull(toValue) || lodash.isUndefined(toValue)) && fromValue !== toValue;
        });
        var nonAnimateAttr = lodash.omit(toAttr, animationKeys);
        var animateToAttr = lodash.pick(toAttr, animationKeys);
        var animateFromAttr = lodash.pick(__assign(__assign({}, defaultTRansformConf), fromAttr), animationKeys);
        animationKeys.forEach(function (key) {
            var value = animateFromAttr[key];
            if (value === undefined || value === 'currentColor') {
                animateFromAttr[key] = _this.getExtendAttr(key);
            }
        });
        this.setAttr(nonAnimateAttr);
        if (typeof duringOrConf === 'object') {
            this.addAnimation(__assign(__assign({ stopped: false, from: animateFromAttr, to: animateToAttr }, defaultSetting), duringOrConf));
        }
        else {
            this.addAnimation({
                from: animateFromAttr,
                to: animateToAttr,
                during: duringOrConf,
                ease: ease,
                callback: callback,
                delay: delay,
                stopped: false,
            });
        }
    };
    Element.prototype.animateMotion = function (animateConf) {
        var _this = this;
        var path = animateConf.path, _a = animateConf.rotate, rotate = _a === void 0 ? 0 : _a, _b = animateConf.during, during = _b === void 0 ? 300 : _b, _c = animateConf.ease, ease = _c === void 0 ? 'Linear' : _c, callback = animateConf.callback, _d = animateConf.delay, delay = _d === void 0 ? 0 : _d;
        this.animateTo({}, {
            ease: ease,
            during: during,
            delay: delay,
            callback: callback,
            onFrame: function (t) {
                var point = path.getPointAtPercent(t);
                var matrix = mat3.createVec3();
                var theta = rotate;
                if (rotate === 'auto') {
                    theta = point.alpha + Math.PI / 2;
                }
                if (rotate === 'auto-reverse') {
                    theta = point.alpha - Math.PI / 2;
                }
                mat3.translate(matrix, matrix, [point.x, point.y]);
                if (theta !== 0) {
                    mat3.rotate(matrix, matrix, theta);
                }
                _this.setAttr('matrix', matrix);
            },
        });
    };
    // eslint-disable-next-line no-unused-vars
    Element.prototype.prevProcessAttr = function (attr) {
        if (attr.position) {
            attr.translateX = attr.position[0];
            attr.translateY = attr.position[1];
        }
        if (attr.scale) {
            attr.scaleX = attr.scale[0];
            attr.scaleY = attr.scale[1];
        }
        if (attr.origin) {
            attr.originX = attr.origin[0];
            attr.originY = attr.origin[1];
        }
    };
    Element.prototype.addAnimation = function (option) {
        this._animations.push(option);
        this._addToFrame();
    };
    // todo gotoend support
    Element.prototype.stopAllAnimation = function () {
        // todo goToEnd
        this._animations.length = 0;
        return this;
    };
    Element.prototype.onFrame = function (now) {
        // clip element maybe usesed for muti component
        if (!now) {
            return;
        }
        if (this._lastFrameTime === now) {
            return;
        }
        if (!this._lastFrameTime && this.attr.onMounted) {
            this.attr.onMounted();
        }
        this._lastFrameTime = now;
        if (this.attr.clip) {
            var clipElement = this.getClipElement();
            clipElement && clipElement.onFrame(now);
        }
        if (!this._animations.length) {
            this._removeFromFrame();
            return;
        }
        var animate = this._animations[0];
        var progress = 0;
        if (animate.startTime) {
            progress = Math.min((now - animate.startTime) / animate.during, 1);
        }
        else {
            animate.startTime = now;
        }
        progress =
            typeof animate.ease === 'function'
                ? animate.ease(progress)
                : easingFunctions[animate.ease || 'Linear'](progress);
        var fn = interpolate;
        this.startAttrTransaction();
        for (var key in animate.to) {
            if (key === 'color' || key === 'fill' || key === 'stroke' || key === 'shadowColor') {
                fn = interpolateColor;
            }
            else if (key === 'pathData') {
                fn = interpolatePath;
            }
            else {
                fn = interpolate;
            }
            this.setAttr(key, fn(animate.from[key], animate.to[key], progress));
        }
        if (progress === 1) {
            animate.callback && animate.callback();
            animate.stopped = true;
        }
        animate.onFrame && animate.onFrame(progress);
        progress >= 1 && this._animations.shift();
        animate = null;
        if (!this._animations.length) {
            this._removeFromFrame();
        }
        this.endAttrTransaction();
    };
    Element.prototype.getClipElement = function () {
        var clip = this.attr.clip;
        if (!clip) {
            return;
        }
        if (clip instanceof Element) {
            return clip;
        }
        if (clip.current instanceof Element) {
            return clip.current;
        }
    };
    /* ************ AnimateAble End ******************* */
    /* ************ TransformAble Begin ******************* */
    Element.prototype.getTransform = function (nullable) {
        if (nullable === void 0) { nullable = false; }
        if (!this._transform || this._transformDirty) {
            this._transform = this._computeTransform();
            this._transformDirty = false;
        }
        return nullable ? this._transform : this._transform || IDENTRY_MATRIX;
    };
    Element.prototype.getGlobalTransform = function (nullable) {
        if (nullable === void 0) { nullable = false; }
        if (!this._absTransform || this._absTransformDirty) {
            this._absTransform = this._computeGlobalTransform();
            this._absTransformDirty = false;
        }
        return nullable ? this._absTransform : this._absTransform || IDENTRY_MATRIX;
    };
    Element.prototype.dirtyClientBoundingRect = function () {
        var _a;
        this._clientBoundingRectDirty = true;
        this._currentPaintAreaDirty = true;
        (_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.dirtyBBox();
    };
    Element.prototype._computeTransform = function () {
        var out = this._transform ? mat3.identity(this._transform) : mat3.createVec3();
        var _a = this.attr, _b = _a.rotation, rotation = _b === void 0 ? 0 : _b, _c = _a.originX, originX = _c === void 0 ? 0 : _c, _d = _a.originY, originY = _d === void 0 ? 0 : _d, _e = _a.scaleX, scaleX = _e === void 0 ? 1 : _e, _f = _a.scaleY, scaleY = _f === void 0 ? 1 : _f, _g = _a.translateX, translateX = _g === void 0 ? 0 : _g, _h = _a.translateY, translateY = _h === void 0 ? 0 : _h, matrix = _a.matrix;
        var flagDirty = false;
        if (translateX !== 0 || translateY !== 0) {
            flagDirty = true;
            out[6] = translateX;
            out[7] = translateY;
        }
        if (rotation !== 0) {
            flagDirty = true;
            transformUtils.rotate(out, rotation, originX, originY);
        }
        if (scaleX !== 1 || scaleY !== 1) {
            flagDirty = true;
            transformUtils.scale(out, scaleX, scaleY, originX, originY);
        }
        if (matrix) {
            flagDirty = true;
            mat3.multiply(out, out, matrix);
        }
        return flagDirty ? out : null;
    };
    Element.prototype.dirtyTransform = function () {
        this._transformDirty = true;
        this.dirtyGlobalTransform();
    };
    Element.prototype.dirtyGlobalTransform = function () {
        this._absTransformDirty = true;
        this.dirtyClientBoundingRect();
        if (this.ownerRender && this.ownerRender.renderer === 'svg' && this.attr.strokeNoScale) {
            this.ownerRender.dirty(this);
        }
    };
    Element.prototype.dirtyBBox = function () {
        this._bboxDirty = true;
        this.dirtyClientBoundingRect();
    };
    Element.prototype._mountClip = function () {
        var clip = this.getClipElement();
        if (clip && this.ownerRender) {
            clip.isClip = true;
            clip.ownerRender = this.ownerRender;
        }
    };
    Element.prototype._computeGlobalTransform = function () {
        var parentTransform = this.parentNode
            ? this.parentNode.getGlobalTransform(true)
            : null;
        var selfTransform = this.getTransform(true);
        var _a = this._dragOffset, dx = _a[0], dy = _a[1];
        if (!parentTransform && !selfTransform && dx === 0 && dy === 0) {
            return null;
        }
        var out = this._absTransform ? mat3.identity(this._absTransform) : mat3.createVec3();
        if (dx !== 0 || dy !== 0) {
            mat3.translate(out, out, this._dragOffset);
        }
        if (parentTransform) {
            mat3.multiply(out, out, parentTransform);
        }
        if (selfTransform) {
            mat3.multiply(out, out, selfTransform);
        }
        return out;
    };
    Element.prototype._removeSVGAttribute = function (attr) {
        this.ownerRender.getPainter().removeNodeAttribute(this, attr);
    };
    Element.prototype._addToFrame = function () {
        if (this.ownerRender) {
            this._inFrameAble = true;
            this.ownerRender.__addFrameableElement(this);
        }
    };
    Element.prototype._removeFromFrame = function () {
        var _a;
        this._inFrameAble = false;
        (_a = this.ownerRender) === null || _a === void 0 ? void 0 : _a.__removeFrameableElement(this);
    };
    return Element;
}(Eventful));
export default Element;
